var _excluded = ["contextPanel", "detailPanel", "title", "children", "footer", "panelState", "twoPanelBreakpoint", "preferredMainWidth", "expandedContext", "headerActions", "contextButtonPlacement"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Navbar, Button, ButtonGroup, NavbarGroup, Alignment, Intent, Position } from "@blueprintjs/core";
import hyper from "@macrostrat/hyper";
import styles from "./main.module.sass";
import { useReducer, useEffect } from "react";
import useElementDimensions from "use-element-dimensions";
import { useContext, createContext } from "react";
import classNames from "classnames";
var h = hyper.styled(styles);
var SidePanel;

(function (SidePanel) {
  SidePanel["Context"] = "context";
  SidePanel["Detail"] = "detail";
})(SidePanel || (SidePanel = {}));

function openPanels(panelState) {
  var keys = Object.keys(panelState);
  return new Set(keys.filter(function (k) {
    return panelState[k];
  }));
}

var LayoutDispatchContext = /*#__PURE__*/createContext(function (a) {
  return a;
});

function useLayoutDispatch() {
  return useContext(LayoutDispatchContext);
}

function layoutReducer(state, action) {
  var _shouldShow;

  var panel;
  var shouldShow;

  switch (action.type) {
    case "set-is-reduced":
      return _objectSpread(_objectSpread({}, state), {}, {
        isReduced: action.value
      });

    case "show-panel":
      shouldShow = action.shouldShow;

    case "toggle-panel":
      panel = action.panel;
      (_shouldShow = shouldShow) !== null && _shouldShow !== void 0 ? _shouldShow : shouldShow = !state.panelState[panel];

      var panelState = _objectSpread(_objectSpread({}, state.panelState), {}, _defineProperty({}, panel, shouldShow));

      var keyPanel = state.keyPanel;

      if (shouldShow) {
        keyPanel = panel;
      } else if (state.keyPanel == panel) {
        keyPanel = null;
      }

      var currentPanels = openPanels(panelState);

      if (currentPanels.size == 1) {
        keyPanel = currentPanels.values().next().value;
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        panelState: panelState,
        keyPanel: keyPanel
      });
  }
}

function buttonProps(panel, desiredState, actualState, dispatch) {
  var active = desiredState[panel];
  var isActuallyShown = active && active == actualState[panel];
  return {
    active: active,
    minimal: true,
    intent: isActuallyShown ? Intent.PRIMARY : null,
    onClick: function onClick() {
      dispatch({
        type: "show-panel",
        panel: panel,
        shouldShow: !isActuallyShown
      });
    }
  };
}

function ThreeColumnLayout(props) {
  var _size$width;

  var contextPanel = props.contextPanel,
      detailPanel = props.detailPanel,
      _props$title = props.title,
      title = _props$title === void 0 ? "User interface" : _props$title,
      children = props.children,
      footer = props.footer,
      _props$panelState = props.panelState,
      panelState = _props$panelState === void 0 ? {} : _props$panelState,
      _props$twoPanelBreakp = props.twoPanelBreakpoint,
      twoPanelBreakpoint = _props$twoPanelBreakp === void 0 ? 800 : _props$twoPanelBreakp,
      preferredMainWidth = props.preferredMainWidth,
      _props$expandedContex = props.expandedContext,
      expandedContext = _props$expandedContex === void 0 ? false : _props$expandedContex,
      _props$headerActions = props.headerActions,
      headerActions = _props$headerActions === void 0 ? null : _props$headerActions,
      _props$contextButtonP = props.contextButtonPlacement,
      contextButtonPlacement = _props$contextButtonP === void 0 ? Position.LEFT : _props$contextButtonP,
      rest = _objectWithoutProperties(props, _excluded);

  var keyPanel = null;

  if (panelState.detail) {
    keyPanel = SidePanel.Detail;
  } else if (panelState.context) {
    keyPanel = SidePanel.Context;
  }

  var _useReducer = useReducer(layoutReducer, {
    panelState: _objectSpread({
      context: true
    }, panelState),
    keyPanel: keyPanel,
    isReduced: false
  }, undefined),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      layoutState = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useElementDimensions = useElementDimensions(),
      _useElementDimensions2 = _slicedToArray(_useElementDimensions, 2),
      size = _useElementDimensions2[0],
      ref = _useElementDimensions2[1];

  var _useElementDimensions3 = useElementDimensions(),
      _useElementDimensions4 = _slicedToArray(_useElementDimensions3, 2),
      mainSize = _useElementDimensions4[0],
      mainRef = _useElementDimensions4[1];

  var panelDesiredState = _objectSpread(_objectSpread({}, layoutState.panelState), panelState);

  var panelActualState = _objectSpread({}, panelDesiredState);

  var nonKeyPanel = layoutState.keyPanel == SidePanel.Context ? SidePanel.Detail : SidePanel.Context; // We'd like the main panel to take up at least half the screen width

  var preferredMainPanelWidth = preferredMainWidth !== null && preferredMainWidth !== void 0 ? preferredMainWidth : Math.max(((_size$width = size === null || size === void 0 ? void 0 : size.width) !== null && _size$width !== void 0 ? _size$width : 0) * 0.5, twoPanelBreakpoint * 0.66);

  if (layoutState.isReduced) {
    panelActualState[nonKeyPanel] = false;
  }

  if (expandedContext) {
    panelActualState[SidePanel.Context] = true;
    panelActualState[SidePanel.Detail] = false;
  }

  useEffect(function () {
    if (openPanels(panelActualState).size <= 1) {
      return;
    } // Decide whether we need to reduce the layout ONLY when both panels are open


    var shouldReduce = (mainSize === null || mainSize === void 0 ? void 0 : mainSize.width) < preferredMainPanelWidth;
    dispatch({
      type: "set-is-reduced",
      value: shouldReduce
    });
  }, [mainSize]);
  var contextButton = h["if"](contextPanel != null)(Button, _objectSpread({
    icon: "projects"
  }, buttonProps(SidePanel.Context, panelDesiredState, panelActualState, dispatch)));
  return h(LayoutDispatchContext.Provider, {
    value: dispatch
  }, h("div.user-interface", _objectSpread({
    ref: ref
  }, rest), [h(Navbar, [h(Navbar.Group, [h["if"](contextButtonPlacement == "left")([contextButton, h("div.spacer")]), h(Navbar.Heading, null, title)]), h(NavbarGroup, {
    align: Alignment.RIGHT
  }, [headerActions, h("div.spacer"), h(ButtonGroup, {
    minimal: true
  }, [h["if"](contextButtonPlacement == "right")([contextButton]), h["if"](detailPanel != null)(Button, _objectSpread({
    icon: "properties"
  }, buttonProps(SidePanel.Detail, panelDesiredState, panelActualState, dispatch)))])])]), h("div.three-column", [h["if"](contextPanel != null && panelActualState.context)("div.column.context-column", {
    className: classNames({
      expanded: expandedContext !== null && expandedContext !== void 0 ? expandedContext : false
    })
  }, contextPanel), h["if"](children != null)("div.column.main-column", {
    ref: mainRef
  }, children), h["if"](detailPanel != null && panelActualState.detail)("div.column.detail-column", null, detailPanel)]), h["if"](footer != null)("footer", null, footer)]));
}

ThreeColumnLayout.Panels = SidePanel;
export { ThreeColumnLayout, useLayoutDispatch };